export const getDirectDebitsIsFetching = state => state.directDebitsReducer.isFetching;
export const getDirectDebitsIsPosting = state => state.directDebitsReducer.isPosting;
export const getDirectDebitsError = state => state.directDebitsReducer.error;
export const getDirectDebits = state => state.directDebitsReducer.directDebits;
